export enum MREvents {
  ModelSelected = "modelSelected",
  ModelsLoaded = "modelsLoaded",
  ObjectClicked = "objectClicked",
  ModelUpdated = "ModelUpdated",
}